import $ from 'jquery';
window.$ = $;
window.jQuery = $;

import 'jquery-mask-plugin';
import './lib/input-validation-html5';
import './lib/placeholder-shown';
import './lib/jquery-serialize-object';
import './lib/datepicker';

import './module/about-director';
import './module/about-history';
import './module/about-news-slider';
import './module/about-production';
import './module/about-values';
import './module/about-video';
import './module/accordion--simple';
import './module/another-articles-slider';
import './module/auth';
import './module/blog';
import './module/business-video';
import './module/business-slider';
import './module/basket';
import './module/catalog';
import './module/catalog-detail';
import './module/catalog-detail-gallery';
import './module/catalog-detail-documents';
import './module/catalog-detail-purchase';
import './module/catalog-detail-quantity';
import './module/catalog-detail-subscribe';
import './module/catalog-detail-faq';
import './module/catalog-item-to-basket';
import './module/catalog-linked';
import './module/catalog-not-medicine';
import './module/consult';
import './module/content-tabs';
import './module/control-checkbox';
import './module/control-file';
import './module/control-input';
import './module/control-number';
import './module/control-select';
import './module/documents';
import './module/faq-item';
import './module/faq-filter';
import './module/filter';
import './module/footer-subscribe';
import './module/forms';
import './module/header-language';
import './module/index-about';
import './module/index-blog';
import './module/index-catalog';
import './module/index-partnership';
import './module/index-popular';
import './module/index-slider';
import './module/lazyload';
import './module/img-svg-hack';
import './module/left-menu';
import './module/mobile-menu';
import './module/news';
import './module/order';
import './module/personal';
import './module/personal-order';
import './module/personal-delivery';
import './module/popup';
import './module/popup-auth';
import './module/popup-city';
import './module/popup-search';
import './module/popup-tabs';
import './module/popup-question';
import './module/product-slider';
import './module/progress';
import './module/radio-tile';
import './module/referral';
import './module/referral-stats';
import './module/register';
import './module/services-map';
import './module/scroll-top';
// import './module/artlife-store-orders';
import './module/copy-link';
import './module/discounts';
import './module/from-catalog-in-basket';
import './module/gift';
import './service/CheckboxService';
